import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên toa xe:")
], -1)
const _hoisted_8 = { class: "col-3 d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mã toa xe :")
], -1)
const _hoisted_12 = { class: "col-3 d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Số hiệu:")
], -1)
const _hoisted_16 = { class: "col-3 d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ghi chú:")
], -1)
const _hoisted_20 = { class: "col-4 d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Chủng loại:")
], -1)
const _hoisted_24 = { class: "col-4 d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "mt-5 row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, null, -1)
const _hoisted_28 = { class: "col-2 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa') + " toa xe ", 1)
      ]),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "form",
        model: _ctx.toaXeForm,
        rules: _ctx.rules,
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                prop: "ten_toa_xe",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.toaXeForm.ten_toa_xe,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toaXeForm.ten_toa_xe) = $event)),
                    placeholder: "tên toa xe",
                    name: "ten_toa_xe",
                    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_form_item, {
                prop: "ma_toa_xe",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.toaXeForm.ma_toa_xe,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toaXeForm.ma_toa_xe) = $event)),
                    placeholder: "mã toa xe",
                    name: "ma_toa_xe",
                    disabled: !_ctx.isCreating,
                    readonly: !_ctx.isCreating
                  }, null, 8, ["modelValue", "disabled", "readonly"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, {
                prop: "so_hieu",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.toaXeForm.so_hieu,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.toaXeForm.so_hieu) = $event)),
                    placeholder: "số hiệu",
                    name: "so_hieu",
                    onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_form_item, {
                prop: "ghi_chu",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.toaXeForm.ghi_chu,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toaXeForm.ghi_chu) = $event)),
                    type: "textarea",
                    placeholder: "ghi chú",
                    name: "ghi_chu",
                    onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_el_form_item, {
                prop: "id_cha",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.toaXeForm.id_chung_loai,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.toaXeForm.id_chung_loai) = $event)),
                    placeholder: "Danh mục toa xe cha",
                    name: "id_cha"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        value: 0,
                        label: 'Không chọn',
                        readonly: ""
                      })),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chungLoaiItems, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.ten_chung_loai,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.SAVE,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                onClick: _ctx.submit
              }, null, 8, ["button-type", "color-type", "onClick"]),
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.TRASH,
                "color-type": _ctx.ButtonTypeColors.DANGER,
                onClick: _ctx.clear
              }, null, 8, ["button-type", "color-type", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"])
    ])
  ]))
}